/** Admin site forms hosted on help.* (not main SPA / portal shells). */

export const HELP_SITE_FORM_SLUGS = Object.freeze(['contact-us', 'file-claim', 'file-dispute']);

/** Paths that must never be treated as help-hosted site forms. */
export const HELP_SITE_FORM_RESERVED_SEGMENTS = new Set([
  'overview',
  'get-label',
  'orders',
  'addresses',
  'products',
  'analytics',
  'stores',
  'account',
  'settings',
  'portal',
  'portals',
  'login',
  'signup',
  'forgot-password',
  'checkout',
  'track',
  'embed',
  'auth',
  'admin',
  'home',
  'shipping',
  'solutions',
  'integrations',
  'pricing',
  'download',
  'packages',
  'faqs',
  'terms-of-service',
  'privacy-policy',
  'terms',
  'tos',
  'privacy'
]);

const HELP_FORM_ALIASES = Object.freeze({
  contact: 'contact-us',
  'file-a-claim': 'file-claim',
  claim: 'file-claim',
  'file-a-dispute': 'file-dispute',
  dispute: 'file-dispute',
  'chargeback-dispute': 'file-dispute'
});

export function normalizeHelpSiteFormSlug(raw) {
  const s = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/^\/+|\/+$/g, '');
  if (!s || s.includes('/')) return null;
  const normalized = HELP_FORM_ALIASES[s] || s;
  if (HELP_SITE_FORM_RESERVED_SEGMENTS.has(normalized)) return null;
  return normalized;
}

/** Single-segment path that may be a help-hosted site form (trailing slash optional). */
export function helpSiteFormSlugFromPath(pathname) {
  const norm = String(pathname || '').split('?')[0].replace(/\/$/, '') || '/';
  if (norm === '/') return null;
  const parts = norm.replace(/^\//, '').split('/').filter(Boolean);
  if (parts.length !== 1) return null;
  if (parts[0].includes('.')) return null;
  return normalizeHelpSiteFormSlug(parts[0]);
}

export function isBuiltinHelpSiteFormSlug(slug) {
  return HELP_SITE_FORM_SLUGS.includes(String(slug || '').toLowerCase());
}

export function helpSiteFormPath(slug) {
  const raw = String(slug || '').toLowerCase();
  const s = normalizeHelpSiteFormSlug(slug) || (isBuiltinHelpSiteFormSlug(raw) ? raw : null);
  if (!s) return null;
  return `/${s}/`;
}

export function helpSiteFormHref(origin, slug) {
  const path = helpSiteFormPath(slug);
  if (!path) return null;
  const base = String(origin || '').replace(/\/$/, '');
  return `${base}${path}`;
}
